import React, {useState} from 'react';
import {NavLink, useHistory} from 'react-router-dom';
import applogo from '../../../imgs/zombie-logo.svg';
import moreIcon from '../../../imgs/moreicon.svg';
import PostBounty from '../../components/MyBounties/PostBounty';
import {Modal} from 'antd';
import {Dropdown} from 'antd';
import MoreMenu from '../home/MoreMenu';
import {
  ChatIcon,
  DashboardIcon,
  HomeIcon,
  PostIcon,
  SettingIcon,
} from '../SvgIcons/SvgIcons';
import {gql, useMutation, useQuery} from '@apollo/client';
import {BOUNTIES_OFFERS_COUNT} from '../../../graphql/query/bounties';
import {useSelector} from 'react-redux';
import {CHAT_UNREAD_COUNT} from '../../../graphql/query/channels';
import {RESET_UNREAD_COUNT} from '../../../graphql/mutations/messages';

const HomeSidebar = () => {
  const [dashboardCount, setDashboard] = useState(0);
  const [chatCount, setChatCount] = useState(0);

  const history = useHistory();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const userProfile = useSelector((state) => state.strapiRes);

  const {} = useQuery(gql(BOUNTIES_OFFERS_COUNT), {
    variables: {
      bountyPerson: userProfile?.id,
    },
    fetchPolicy: 'cache-and-network',
    onCompleted: ({offersConnection}) =>
      setDashboard(offersConnection.aggregate.count),
  });

  const strapiRes = useSelector((state) => state.strapiRes);

  const {} = useQuery(gql(CHAT_UNREAD_COUNT), {
    fetchPolicy: 'cache-and-network',
    variables: {
      profileId: userProfile?.id,
    },
    onCompleted: ({channelsConnection}) =>
      setChatCount(channelsConnection.aggregate.count),
  });

  const {
    location: {pathname},
  } = history;

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const [resetUnreadCount] = useMutation(gql(RESET_UNREAD_COUNT));

  const handleClearCount = () => {
    resetUnreadCount({
      variables: {
        profileId: userProfile?.id,
      },
    }).then((res) => {
      setChatCount(0);
    });
  };

  return (
    <div className="home-sidebar">
      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={false}
        className="modal-body">
        <PostBounty
          handleCancel={() => {
            setIsModalVisible(false);
          }}
        />
      </Modal>
      <div className="app-logo" onClick={() => history.push(`/${strapiRes?.userName}`)}>
        <img src={applogo} alt="logo" />
      </div>
      <div className="sidebar-menu">
        <div>
          <NavLink
            className="sidebar-links"
            exact={true}
            to={`/${strapiRes.userName}`}>
            <span>
              <HomeIcon />
            </span>
            Home
          </NavLink>

          <NavLink className="sidebar-links" exact={true} to="/mybounties">
            <span>
              <DashboardIcon />
            </span>
            Dashboard
            {dashboardCount !== 0 && (
              <div className="badge">{dashboardCount}</div>
            )}
          </NavLink>

          <NavLink
            className="sidebar-links"
            exact={true}
            to="/chat"
            onClick={handleClearCount}>
            <span>
              <ChatIcon />
            </span>
            Chat
            {chatCount !== 0 && <div className="badge">{chatCount}</div>}
          </NavLink>

          <NavLink className="sidebar-links" to="/account">
            <span>
              <SettingIcon />
            </span>
            Account
          </NavLink>

          <button className="post-btn" exact to="/post" onClick={showModal}>
            <span>
              <PostIcon />
            </span>
            Post a bounty
          </button>
        </div>
        <div className="more-menu">
          <Dropdown
            overlay={<MoreMenu history={history} />}
            placement="bottomCenter"
            trigger={['click']}>
            <NavLink className="sidebar-links" to="/more">
              <span>
                <img src={moreIcon} alt="logo" />
              </span>
              More
            </NavLink>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default HomeSidebar;
